module.exports = __webpack_public_path__ + "img/symbol_6.f00d74f4.png";